import React from 'react';
import ContextStrip from '../../../Elements/DesignSystem/ContextStrip';
import Breadcrumb from '../../../Elements/DesignSystem/Breadcrumb';
import Chip from '../../../Elements/DesignSystem/Chip';
import PlanningMain from '../PlanningMain';
import PlanningList from '../PlanningItem/PlanningList';

function PlanningDetailHeader({ firstItem, pricingId }) {
  if (!firstItem) return null;

  return (
    <ContextStrip>
      <Breadcrumb
        items={[
          {
            text: 'Planning — Services',
            title: 'Planning - Services',
            link: <PlanningMain />,
            url: 'planning',
          },
          {
            text: 'Planning Items',
            title: 'Planning - Planning Items',
            link: <PlanningList serviceId={firstItem.ServiceId} />,
            url: `planning_planningList/search?ServiceId=${firstItem.ServiceId}`,
          },
          { text: 'Planning Details', title: 'Planning - Planning Details', isCurrentPage: true },
        ]}
      />
      <div className='meta'>
        <Chip label='Country'>{firstItem.CountryName}</Chip>
        <Chip label='Opportunity'>
          {firstItem.OpportunityName} · {firstItem.OpportunityId}
        </Chip>
        <Chip label='Service'>
          {firstItem.ServiceName} · {firstItem.ServiceId}
        </Chip>
      </div>
    </ContextStrip>
  );
}

export default PlanningDetailHeader;
